import { useState } from "react";
import '../../App.css';
import FeedbackModal from "./FeedbackModal";
import ThumbsUpIcon from "../icons/ThumbsUp";
import ThumbsDownIcon from "../icons/ThumbsDown";
import { useChat } from "../../contexts/ChatProvider";

export default function Feedback({conversation_id, existing_feedback}) {
  const {theme, submitFeedback} = useChat();
  const [selected, setSelected] = useState(existing_feedback?.type == "positive" ? "up" : existing_feedback?.type == "negative" ? "down" : null);
  const [open, setOpen] = useState(false);
  //console.log("existing_feedback", existing_feedback)
  const handleClick = (type) => {
    setSelected(type);
    setOpen(true);
  };

  return (
    <>
      <div 
        className="feedback-buttons"
      >
        <button
          onClick={() => {
            handleClick("up");
            submitFeedback(conversation_id, "positive")
          }}
          disabled={selected === "up"}
          aria-label="Thumbs Up"
        >
          <ThumbsUpIcon color={theme} fill={selected == "up" ? true : false}/>
        </button>

        <button
          onClick={() => {
            handleClick("down");
            submitFeedback(conversation_id, "negative")
          }}
          aria-label="Thumbs Down"
          disabled={selected == "down"}
        >
          <ThumbsDownIcon color={theme} fill={selected == "down" ? true : false}/>
        </button>
      </div>

      <FeedbackModal
        open={open}
        type={selected}
        conversation_id={conversation_id}
        onClose={() => setOpen(false)}
        onSubmit={submitFeedback}
        existing_feedback_message={existing_feedback?.message}
      />
    </>
  );
}